import React, {useContext} from "react";
import {Platform} from "react-native";
import Button from "./Button";
import {StoreContext} from "./StoreContextProvider";
import {useNavigation} from "@react-navigation/native";
import {colors} from "../assets/styles/colors";
import Div from "../lib/Div";
import {isFullSwing, StartingPage} from "../constants";
import Btn from "./Btn";
import P from "../lib/P";

type Props = { tabIndex: number, onChange: (val: number) => void };

const AccountNavBar = (props: Props) => {
  const {tabIndex} = props;
  const Context = useContext(StoreContext);
  const navigation: any = useNavigation();
  const {cancelModalConfig} = Context;

  const Logout = () => {
    Context.setCancelModalConfig({
      visible: true, title: 'Logout', subtitle: 'Are you sure you want to logout?',
      onExit: () => {
        Context.logout().then(() => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          setTimeout(() => {
            if (Platform.OS === 'web') window.location.reload();
          }, 150);
          navigation.reset({index: 0, routes: [{name: StartingPage}]});
        });
      },
      onResume: () => {
        Context.setCancelModalConfig({...cancelModalConfig, visible: false});
      }
    });
  };

  return (
    <Div row w={isFullSwing ? '100%' : 387} rounded={70} borderWidth={isFullSwing ? 0 : 1}
         borderColor={colors.settings_border} bg={isFullSwing ? 'transparent' : colors.help_icon} mx="auto">
      {!isFullSwing && (
        <Button
          text="PROFILE" onPress={() => props.onChange(0)} bg={tabIndex === 0 ? colors.navSelected : 'transparent'}
          fontWeight={tabIndex === 0 ? '700' : '500'}
          borderColor={tabIndex === 0 ? colors.settings_border : 'transparent'}
          w={90} h={42} radius={70} color="white" fontSize={14} borderWidth={1}
        />
      )}

      {isFullSwing ? (
        <Btn flex={1} onPress={() => props.onChange(1)} borderBottomWidth={2}
             borderColor={tabIndex === 1 ? '#3369FF' : 'transparent'}>
          <P lh={40} ta="center" fontFamily="DavisSans-Medium" color={tabIndex === 1 ? 'white' : '#BBBCBF'}>Deposit</P>
        </Btn>
      ) : (
        <Button
          text="DEPOSIT" onPress={() => props.onChange(1)} bg={tabIndex === 1 ? colors.navSelected : 'transparent'}
          fontWeight={tabIndex === 1 ? '700' : '500'}
          borderColor={tabIndex === 1 ? colors.settings_border : 'transparent'}
          w={90} h={42} radius={70} color="white" fontSize={14} borderWidth={1}
        />
      )}

      {isFullSwing ? (
        <Btn flex={1} onPress={() => props.onChange(2)} borderBottomWidth={2}
             borderColor={tabIndex === 2 ? '#3369FF' : 'transparent'}>
          <P lh={40} ta="center" fontFamily="DavisSans-Medium" color={tabIndex === 2 ? 'white' : '#BBBCBF'}>
            Withdrawal
          </P>
        </Btn>
      ) : (
        <Button
          text="WITHDRAWAL" onPress={() => props.onChange(2)} bg={tabIndex === 2 ? colors.navSelected : 'transparent'}
          fontWeight={tabIndex === 2 ? '700' : '500'}
          borderColor={tabIndex === 2 ? colors.settings_border : 'transparent'}
          w={120} h={42} radius={70} color="white" fontSize={14} borderWidth={1}
        />
      )}

      {!isFullSwing && (
        <Button
          text="SIGN OUT" onPress={Logout} bg="transparent" fontWeight="500"
          w={87} h={42} color="white" fontSize={14}
        />
      )}
    </Div>
  );
};

export default React.memo(AccountNavBar);
